export default __webpack_public_path__ + "static/media/jokerpokertableWnd.334531bd.webp";